module.exports = "<mat-card>\n  <img mat-card-image alt=\"page not found\"  src=\"assets/images/page-not-found.jpg\">\n</mat-card>"